import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import lee from '../../../assets/images/virtualstart/Lee.jpg';
import {TiTickOutline} from 'react-icons/ti';
import screenshot from '../../../assets/images/virtualstart/virtualexhangeio.png';

import './furthur_styles/affyndetails.css';

export default function Affyndetails() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col>
            <div className="affyn_intro">
                <h2>Affyn</h2>
                <div>
                    <p>
                    Affyn is a Singapore-based company, using blockchain-powered technology, to develop mobile games
                    with integrated geolocation and augmented reality capability. Affyn is pioneering the gaming model
                    with a sustainable play-and-earn economy
                    where rewards earned in the virtual world have the ability to also be utilized in the real world.
                    </p>
                </div>
            </div>
            <div className="affyn_project_details">
              <div className='d-flex gap-3 align-items-center mt-5 mb-5'>
                <span className='affyn_pro_dt_sp m-0'></span>
                <h2 className='m-0'>Project Introduction</h2>  
              </div>  
              <div className="card affyn_pro_det_card">
                <img src={screenshot} alt="" className='img-fluid' />
              </div>
            </div>
          </Col>  
          <Col>
            {/* Card 1 */}
            <div className="card affyn_details_card mt-3">
                <div>
                   <h4>Founder</h4> 
                </div>
                <div className='d-flex gap-3 align-items-center'>
                    <img src={lee} alt="" className='rounded-circle ' />
                    <span>Lucaz Lee</span>
                </div>
                <div>
                  <p>
                    Lucaz Lee is the founder and CEO of Affyn. He has over a decade of experience leading
                    international teams to growth and success,
                    including helping to launch a start-up that was acquired by a NASDAQ-listed firm.
                  </p>
                </div>
            </div>
            {/* Card 2 */}
            <div className="card affyn_details_card mt-3">
              <div>
                <h4>Requirement for participants</h4>
              </div>
              <div className='d-flex gap-2 align-items-center mt-2'>
                <span className='bg-dark rounded-circle p-1'>
                    <TiTickOutline />
                </span>
                <p className='m-0'>Participants should <a href="">register</a> on Virtual Exchange and <a href="">Log in</a></p>
              </div>
              <div className='d-flex gap-2 align-items-center mt-2'>
                <span className='bg-dark rounded-circle p-1'>
                    <TiTickOutline />
                </span>
                <p className='m-0'>After logging in, complete user identity verification</p>
              </div>
              <div className='d-flex gap-2 align-items-center mt-2'>
                <span className='bg-dark rounded-circle p-1'>
                    <TiTickOutline />
                </span>
                <p className='m-0'>Total assets in your wallet {'>'} 500</p>
              </div>
              <div className='mt-3'>
                <p>
                    Make sure you have enough balance of supported currency for the sale.
                    1 copy requires <span>20 USDT</span> in balance. The assets will not 
                    be deducted.
                </p>
              </div>
            </div>
            {/* Card 3 */}
            <div className="card affyn_details_card mt-3">
              <div>
                <h4>*Risk Warning</h4>
              </div>
              <div>
                <div className='d-flex gap-1'>
                    <span>1.</span>
                    <p>
                     The Startup project is still in its initial stage, factors including the operation
                       and underlying technology of the project,
                       and other related regulatory activities might contribute to significant risks.
                    </p>
                </div>
                <div className='d-flex gap-1'>
                 <span>2.</span>   
                <p>
                    Advanced technical and financial knowledge is required to understand and evaluate
                    the inherent risks of crypto-asset investment.
                </p>
                </div>
                <div className='d-flex gap-1'>
                  <span>3.</span>  
                <p>
                     The volatility of market is high, and the price of token might fluctuate drastically
                    , due to technical, regulatory and marketing factors etc.
                </p>
                </div>
                <div className='d-flex gap-1'>
                <span>4.</span>    
                <p>
                    Users may not be able to withdraw all the purchased tokens due to technical issues of
                    the project or Virtual Exchange.
                </p>
                </div>
              </div>
            </div>
          </Col>  
        </Row>
      </Container>
    </>
  )
}
